import React from 'react'

import { Box, Chevron, Icon, PopoverMenu } from '@factorialco/deprecated-design-system'
import { FORMAT_ELEMENT_COMMAND, LexicalEditor } from 'lexical'

interface Props {
  editor: LexicalEditor
  alignmentType: SupportedAlignmentTypes
}

export type SupportedAlignmentTypes = 'left' | 'right' | 'left' | 'justify' | 'center'

export const AlignmentFormatDropDown = ({ editor, alignmentType }: Props) => {
  const alignmentTypeIcon: Record<
    SupportedAlignmentTypes,
    React.ComponentProps<typeof Icon.Medium>['icon']
  > = {
    left: 'align-text-left',
    right: 'align-text-right',
    center: 'align-text-center',
    justify: 'align-text-justify',
  }

  const alignNode = (alignment: SupportedAlignmentTypes) =>
    editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, alignment)

  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Box className="toolbar-item" flexDirection="row" alignItems="center" gap="s4">
          <Icon.Medium icon={alignmentTypeIcon[alignmentType || 'left']} color="grey800" />
          <Chevron type="terciary" direction="down" />
        </Box>
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="start">
        <PopoverMenu.TouchableOption
          title="Left"
          icon="align-text-left"
          onClick={() => alignNode('left')}
        />
        <PopoverMenu.TouchableOption
          title="Center"
          icon="align-text-center"
          onClick={() => alignNode('center')}
        />
        <PopoverMenu.TouchableOption
          title="Right"
          icon="align-text-right"
          onClick={() => alignNode('right')}
        />
        <PopoverMenu.TouchableOption
          title="Justify"
          icon="align-text-justify"
          onClick={() => alignNode('justify')}
        />
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}
